import { LocalStorageKey } from '@diritto/common/utils/localStorage';
import { ModalType } from 'constants/modal';
import { DateTime } from 'luxon';
import { useCallback } from 'react';
import { LocalStorage } from 'utils/LocalStorage';
import { ModalHandler } from 'utils/ModalHandler';

const HIDE_MODAL_TIME = 90; // 90 days

export const useShowFavoriteCategoryBottomModal = () => {
  const markHideTime = useCallback(() => {
    LocalStorage.setItem(
      LocalStorageKey.FavoriteCategoryBottomModalHideTime,
      DateTime.now().toJSDate().getTime().toString(),
    );
  }, []);

  const showFavoriteCategoryBottomModal = useCallback(() => {
    setTimeout(() => {
      ModalHandler.show(ModalType.SelectFavoriteCategory, {
        onCancel: markHideTime,
      });
    }, 500);
  }, [markHideTime]);

  return useCallback(() => {
    const hideTime = LocalStorage.getItem(LocalStorageKey.FavoriteCategoryBottomModalHideTime);
    if (!hideTime) {
      showFavoriteCategoryBottomModal();
      return;
    }

    if (DateTime.now().minus({ days: HIDE_MODAL_TIME }) > DateTime.fromMillis(Number(hideTime as string))) {
      showFavoriteCategoryBottomModal();
    }
  }, [showFavoriteCategoryBottomModal]);
};
